import { NgFor } from '@angular/common';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatSelect, MatOption } from '@angular/material/select';
import { AgrI18nSharedModule } from '@next/core-lib/i18n';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { SortMode } from 'src/app/models/sort-mode.model';
import { SortOption } from 'src/app/models/sort-option.model';

@UntilDestroy()
@Component({
  selector: 'app-table-sort-mode',
  templateUrl: './table-sort-mode.component.html',
  styleUrls: ['./table-sort-mode.component.scss'],
  imports: [MatFormField, MatLabel, MatSelect, FormsModule, ReactiveFormsModule, NgFor, MatOption, AgrI18nSharedModule],
})
export class TableSortModeComponent implements OnInit {
  @Output() sortModeChange: EventEmitter<SortMode> = new EventEmitter();

  readonly tableSortModeControl = new FormControl(SortMode.default);
  sortOptions: SortOption[] = [];

  ngOnInit() {
    for (const [key, value] of Object.entries(SortMode)) {
      this.sortOptions.push({ key, value });
    }

    this.tableSortModeControl.valueChanges.pipe(untilDestroyed(this)).subscribe((sortMode: SortMode) => this.sortModeChange.emit(sortMode));
  }
}
